export default __webpack_public_path__ + "static/media/idocsignSidebarGrey.a9171cc2.png";